module.exports = __webpack_public_path__ + "img/illustration-login.f66f7ce1.svg";